import { render, staticRenderFns } from "./search-highlight.vue?vue&type=template&id=79c45775"
import script from "./search-highlight.vue?vue&type=script&lang=js"
export * from "./search-highlight.vue?vue&type=script&lang=js"
import style0 from "./search-highlight.vue?vue&type=style&index=0&id=79c45775&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports